export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-13.2ddd5992.png";